import { MaterialIcon } from "../../components/Icons";
import { async } from "../../libs/async";
import { compressFile } from "../../libs/compressImage";
import { BoxAlert } from "../../components/Alerts";

const FilesSection = ({ data: { formik, addFileToComprobantes, comprobantes, deleteComprobante } }) => {
  const labelStyles =
    "flex items-center justify-between max-w-[200px] gap-1 opacity-70 border-b shadow-3 bg-neutral-200 rounded-lg py-1 px-4 pl-4 mt-1";

  return (
    <fieldset>
      <legend className="text-sm mb-5 opacity-90">Presentá comprobantes</legend>
      <div className="grid lg:grid-cols-2 sm:grid-cols-1">
        <div className="flex flex-col gap-6">
          <div>
            <p className="mb-2 opacity-60 text-sm">Comprobantes de pago</p>
            <div className="flex items-center flex-wrap gap-2">
              {comprobantes &&
                comprobantes.length > 0 &&
                comprobantes.map((file, index) => {
                  const fileName = file.name.length > 30 ? file.name.slice(0, 20) + "..." : file.name;
                  return (
                    <label className={labelStyles} key={index}>
                      <p className="text-xs text-ellipsis overflow-hidden">{fileName}</p>
                      <button type="button" onClick={() => deleteComprobante(file)}>
                        <MaterialIcon extrastyles="text-lg" icon="close" />
                      </button>
                    </label>
                  );
                })}
            </div>
            {comprobantes.length < 5 && <ComprobantesUploader addFileToComprobantes={addFileToComprobantes} />}
          </div>
        </div>
        <div className="flex flex-col gap-6">
        </div>
      </div>
    </fieldset>
  );
};

const ComprobantesUploader = ({ addFileToComprobantes }) => {
  const chooseFile = async (e) => {
    const files = await async.map(Array.from(e?.currentTarget?.files), compressFile);
    let reader = new FileReader();
    reader.readAsDataURL(files[0]);
    reader.onload = () => {
      const fileData = reader.result.split(",")[1];
      addFileToComprobantes({
        data: fileData,
        type: files[0].type.split("/")[1],
        name: files[0].name,
      });
    };
  };

  const labelStyles =
    "flex items-center gap-1 cursor-pointer border-[2px] border-dashed opacity-70 rounded-lg py-1 px-4 pl-4 max-w-max mt-3";

  return (
    <label className={labelStyles}>
      <input type="file" accept="image/*" className="hidden" onChange={chooseFile} />
      <MaterialIcon icon="attach_file" extrastyles="text-lg" />
      <p className="text-xs">Adjuntar comprobante</p>
    </label>
  );
};

export default FilesSection;
